export var ClassicWaveform;
(function (ClassicWaveform) {
    ClassicWaveform[ClassicWaveform["sine"] = 0] = "sine";
    ClassicWaveform[ClassicWaveform["triangle"] = 1] = "triangle";
    ClassicWaveform[ClassicWaveform["saw"] = 2] = "saw";
    ClassicWaveform[ClassicWaveform["square"] = 3] = "square";
})(ClassicWaveform || (ClassicWaveform = {}));
